import { UserResponse } from "api/resources/assessments/types"

export type CpatAssessment = {
  id: number
  status: CpatAttemptStatus
  startTime?: string
  assessment: {
    id: number
    name: string
    totalQuestions: number
    duration: string
    startTime?: string
    endTime?: string
    maintainSequence: boolean
    assessmentType: CpatAssessmentType
    endTimeStrict: boolean
    slug: string
    description?: string
    instructions?: string
    attempt?: number
    isProctored: boolean
    maxWarningCount?: number
    reportVisibility: "visible_to_all" | "visible_to_school" | "visible_to_none"
  }
}

export type CpatAttemptWarning = {
  id: number
  attempt: number
  warningData: Record<string, number>
  totalWarningCount: number
}

export type CpatAssessmentViolations = {
  goodImages?: string[]
  noFaceImages: string[]
  multipleFaceImages: string[]
  faceStats: {
    good: number
    noFace: number
    totalImages: number
    multipleFaces: number
  }
  faceViolationPercentage: number
  violations: {
    violationTypes: Record<string, number>
    totalViolations: number
  }
  dateCreated: string
}

export enum CpatAssessmentType {
  LIVE = 1,
  MOCK = 2,
}

export enum CpatAttemptStatus {
  NOT_STARTED = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
  DISQUALIFIED = 4,
}

export type CpatAttempt = {
  id: number
  startTime?: string
  responses: CpatAssessmentQuestion[]
  assessment: CpatAssessmentSummary
}

export type CpatImageValidation = {
  goodImage: boolean
}

export type CpatAssessmentSummary = {
  id: number
  duration: string
  startTime: string
  endTime?: string
  endTimeStrict: boolean
  assessmentType: CpatAssessmentType
  isProctored: boolean
  maxWarningCount?: number
}

export enum QuestionType {
  SINGLE_CORRECT = 1,
  MULTIPLE_CORRECT = 2,
  FILL_IN_THE_BLANKS = 3,
}

export enum QuestionStatus {
  UNATTEMPTED = 1,
  ATTEMPTED,
  MARKED_FOR_REVIEW,
  UNREAD,
}

export type CpatAssessmentQuestion = {
  id: number
  sequence: number
  status: QuestionStatus
  question: {
    id: number
    text: string
    options: string[]
    ordered: boolean
    questionType: QuestionType
  }
  response: UserResponse | null
}

type Organization = {
  id: number
  name: string
  slug?: string
  abbreviation?: string
  imageUrl?: string
}

type Item = {
  uuid?: string
  id: number
  name: string
  image?: string
  slug?: string
  itemType: string
  itemLevel?: string
  duration?: string
}

export type LearningCertificateData = {
  id: string
  userId: string
  holderName: string
  serialNumber: string
  issuedAt: string
  organization?: Organization
  item?: Item
  file?: string
  referenceId?: string
}
